/**
 * <ModalContent />
 *
 * @parent Modal
 * @stateless
 */
import React from 'react';
import classnames from 'classnames';
import getClassBy from 'controllers/class/getClassBy'
import find from 'lodash/find';
import { hotline } from 'vendor/react-redux-hotline';
import Loading from 'components/UI/Loading';
import ClassItem from './ClassItem';
import getClassLesson from 'controllers/class/getClassLesson';
import getAllClassLessons from 'controllers/class/getAllClassLessons';
import LessonList from './LessonList';

const ENROLLED_FIRST = 'ENROLLED_FIRST';

const LESSON_PER_PAGE = 25;
const CLASS_PER_PAGE = 25;
const SEARCH_TIMEOUT = 250;
const MIN_SEARCH_VALUE_LENGTH = 2;

class ModalContent extends React.Component {
  constructor(props) {
    super(props);
    this._loadClassesOntoState = this._loadClassesOntoState.bind(this);
    this._onSearchSelected = this._onSearchSelected.bind(this);
    this._getSelectList = this._getSelectList.bind(this);

    this.onToggleLessonSelect = this.onToggleLessonSelect.bind(this);
    this.loadSelectedClassLesson = this.loadSelectedClassLesson.bind(this);
    this.onSelectClass = this.onSelectClass.bind(this);
    this._handleClassScrolling = this._handleClassScrolling.bind(this);
    this._onSearch = this._onSearch.bind(this);
    this.onToggleCurrentPageLessons = this.onToggleCurrentPageLessons.bind(this);
    this.onPageChanged = this.onPageChanged.bind(this);
    this.selectAllLessonsInClass = this.selectAllLessonsInClass.bind(this);
    const {
      students,
    } = this.props;

    this.state = {
      classList: [],
      students,
      optionsForSearch: [],
      selectedOption: undefined,
      classListOrder: ENROLLED_FIRST,
      selectedClass: {},
      lessonIDSelected: [],
      activePage: 1,
      isloadingMoreLesson: false,
      totalPageAmount: 0,
      isLoadingMoreClass: false,
      activeClassPage: 1,
      totalClassPageAmount: 0,
      classSearchKey: '',
      lessonList: [],
      totalItemsCount: 0,
      pageSelectAllTracker: [],
      isAllLessonsSelected: false
    }
  }

  componentWillMount() {
    this._loadClassesOntoState();
  }

  loadSelectedClassLesson(classID) {
    const {activePage} = this.state;
    this.setState({
      loadingLessons: true
    })
    getClassLesson(classID, {
      amount_per_page: LESSON_PER_PAGE,
      current_page_number: activePage
    })
      .then(({ result, lessonList, total_page_amount, total_lesson_amount })=>{
        if (result === 'success') {
          this.setState({
            loadingLessons: false,
            lessonList,
            totalPageAmount: total_page_amount,
            totalItemsCount: total_lesson_amount,
            activePage: activePage
          }, ()=>{
            let pageSelectAllTracker=[];
            for(let i=0; i<total_page_amount; i++){
              pageSelectAllTracker.push(false)
            }
            this.setState({
              pageSelectAllTracker
            })
            this.props.nextStage();
          });
        }
      })
      .catch((err)=>{
        console.error(err);
      });
  }
  
  onSelectClass(selectedClass) {
    return (e)=>{
      e.stopPropagation();

      const { has_lesson } = selectedClass;

      this.setState({
        selectedClass,
        lessonIDSelected: [],
        loadingLessons: has_lesson, 
        isAllLessonsSelected: false
      }, ()=>{
        this.props.onChange({
          selectedClass,
        });
        this.loadSelectedClassLesson(selectedClass.classID)
      });
    }
  }
  onPageChanged(e){
    const {selectedClass} = this.state;

    this.setState({
      loadingLessons: true
    })
    getClassLesson(selectedClass.classID, {
      amount_per_page: LESSON_PER_PAGE,
      current_page_number: e
    })
      .then(({ result, lessonList, total_page_amount, total_lesson_amount })=>{
        if (result === 'success') {
          this.setState({
            loadingLessons: false,
            lessonList,
            totalPageAmount: total_page_amount,
            totalItemsCount: total_lesson_amount,
            activePage: e
          });
        }
      })
      .catch((err)=>{
        console.error(err);
      });
  }
  loadMoreClasses(){
    const { activeClassPage, totalClassPageAmount, classSearchKey } = this.state;
    const schoolId = parseInt(localStorage.getItem('schoolId'));

    if(activeClassPage< totalClassPageAmount){
      this.setState(prevState => {
        return {...prevState, activeClassPage: prevState.activeClassPage+1, isLoadingMoreClass: true}
      },()=>{

        getClassBy({
          schoolId,
          type: 'group',
          state: 'current',
          amount_per_page: CLASS_PER_PAGE,
          current_page_number: activeClassPage,
          keyword: classSearchKey,
          order_by: 0,
        })
          .then(({classList, page_amount})=>{
            this.setState(prevState=>{
              return {
                ...prevState,
                isLoadingMoreClass: false,
                classList: [...prevState.classList, ...classList],
                totalClassPageAmount: page_amount
              }
            });
          })
          .catch((err)=>{
            console.error(err);
          });
      })
    }

  }
  onToggleLessonSelect(lessonID) {
    return (e) => {
      const { lessonIDSelected } = this.state;
      const idx = lessonIDSelected.indexOf(lessonID);
      if (idx > -1) {
        lessonIDSelected.splice(idx, 1);
      } else {
        lessonIDSelected.push(lessonID);
      }

      this.setState({
        lessonIDSelected,
      }, ()=>{
        this.props.onChange({
          lessonIDSelected,
        });
      });
    }
  }
  onToggleCurrentPageLessons(e){
    e.stopPropagation();
    const {lessonList, lessonIDSelected, activePage, pageSelectAllTracker} = this.state;
    const currentPageSelectAll = pageSelectAllTracker[activePage-1];
    let selectedLessons = lessonIDSelected.slice();
    lessonList.forEach((lesson)=>{
      if(lesson.lesson_status !== 1){
        const lessonId=lesson.lesson_id;
        const idx = selectedLessons.indexOf(lessonId);
        if (idx > -1) {
          if(currentPageSelectAll){
            selectedLessons.splice(idx, 1);
          }
        } else {
          if(!currentPageSelectAll){
            selectedLessons.push(lessonId);
          }
        }
      }
    })
    let selectAllTracker = pageSelectAllTracker.slice();
    selectAllTracker[activePage-1]=!selectAllTracker[activePage-1]
    this.setState({
      lessonIDSelected: selectedLessons,
      pageSelectAllTracker: selectAllTracker
    }, ()=>{
      this.props.onChange({
        lessonIDSelected: selectedLessons
      });
    });
  }
  _loadClassesOntoState() {
    const {classSearchKey, activeClassPage} = this.state;
    const schoolId = parseInt(localStorage.getItem('schoolId'));
    getClassBy({
      schoolId,
      type: 'group',
      state: 'current',
      amount_per_page: CLASS_PER_PAGE,
      current_page_number: activeClassPage,
      keyword: classSearchKey,
      order_by: 0
    })
      .then((res)=>{
        this.setState({
          classList: res.classList,
          totalClassPageAmount: res.page_amount
        });
      })
      .catch((err)=>{
        console.error(err);
      });
  }

  _onSearchSelected(selected) {
    // STEP 1. if selected is empty, which means the select field is clear out.
    // Then, we update with the classList saved in this.
    if (selected === null) {
      this.setState({
        selectedOption: undefined,
        classList: this.savedClassList,
      });
      return;
    }

    // STEP 2. If selected is indeed an list item object, then we recreate
    // this.state.classList by filtering out current list.
    let {
      value: cls
    } = selected

    let newClassList = this.savedClassList.filter((thisCls)=>{
      return thisCls.classID == cls.classID;
    });

    this.setState({
      selectedOption: selected,
      classList: newClassList,
    });
  }

  _onSearch(e) {
    
    const { value = '' } = e.target;

    let classSearchKey = value;

    if (value.length < MIN_SEARCH_VALUE_LENGTH) {
      classSearchKey = '';
    }

    if (this.debouncedSearchTimeout) {
      clearTimeout(this.debouncedSearchTimeout);
    }
    
    this.debouncedSearchTimeout = setTimeout(()=>{
      this.setState({
        classSearchKey,
        activeClassPage: 1,
      }, ()=>{
        this._loadClassesOntoState();
      });
    }, SEARCH_TIMEOUT);

  }
  _handleClassScrolling(){
    const {isLoadingMoreClass} = this.state;
    const BOTTOM_OFFSET = 500;
    if(this.classLoadingScroller && !isLoadingMoreClass && (this.classLoadingScroller.scrollTop >= this.classLoadingScroller.scrollHeight-BOTTOM_OFFSET)){
      this.loadMoreClasses();
    }
  }
  selectAllLessonsInClass(){
    const {selectedClass, isAllLessonsSelected} = this.state;
    if(!isAllLessonsSelected){
      getAllClassLessons(selectedClass.classID, {
        detail: 0
      })
        .then((res)=>{
          let lessonIDSelected = [];
          if(res.lesson_list.length>0){
            res.lesson_list.forEach((lesson)=>{
              if(lesson.lesson_status!==1){
                lessonIDSelected.push(lesson.lesson_id);
              }
            })
          }
          let pageSelectAllTracker=this.state.pageSelectAllTracker;
          for(let i=0; i<pageSelectAllTracker.length; i++){
            pageSelectAllTracker[i]=true;
          }
          this.setState({pageSelectAllTracker,lessonIDSelected, isAllLessonsSelected: !isAllLessonsSelected},()=>{
            this.props.onChange({lessonIDSelected})
          })
        })
        .catch((err)=>{
          console.error(err);
        });
    }else {
      let pageSelectAllTracker=this.state.pageSelectAllTracker;
      for(let i=0; i<pageSelectAllTracker.length; i++){
        pageSelectAllTracker[i]=false;
      }
      this.setState({pageSelectAllTracker, lessonIDSelected: [], isAllLessonsSelected: !isAllLessonsSelected},()=>{
        this.props.onChange({lessonIDSelected: []})
      })
    }
  }
  render() {

    let {
      selectedOption,
      isLoadingMoreClass,
      isloadingMoreLesson,
      loadingLessons, 
      lessonList, 
      lessonIDSelected,
      selectedClass,
      pageSelectAllTracker,
      activePage,
      totalItemsCount,
      isAllLessonsSelected
    } = this.state;

    const { stage }=this.props;
    return (
      <div className={classnames({'select-none': typeof selectedOption == 'undefined' })}>
        { (isLoadingMoreClass || isloadingMoreLesson) && <Loading /> }
        <div className='content'>
          {
            stage ==='enrollClass' &&
            <div>
              <div className='searchbar-wrapper'>
                <input 
                  type='text' 
                  classname='form-control'
                  onChange={this._onSearch}
                  placeholder={__('Search Class Name', 'student')}
                />
              </div>
              <div className='label-section'>
                <label>{__('Class', 'student')}</label>
              </div>
              <div className='select-list' ref={scroller=> this.classLoadingScroller = scroller} onScroll={this._handleClassScrolling}>
                {this._getSelectList()}
              </div>
            </div>
          }
          {
            stage === 'enrollLessons' &&
            <LessonList 
              cls={selectedClass}
              lessonList={lessonList}
              loadingLessons={loadingLessons}
              isloadingMoreLesson={isloadingMoreLesson}
              onToggleLessonSelect={this.onToggleLessonSelect}
              lessonIDSelected={lessonIDSelected}
              loadMoreLessons={this.loadMoreLessons}
              onPreviousStageSelect={this.props.onPreviousStageSelect}
              onToggleCurrentPageLessons={(e)=>this.onToggleCurrentPageLessons(e)}
              pageSelectAllTracker={pageSelectAllTracker}
              onPageChanged={this.onPageChanged}
              pagination={{activePage: activePage, totalItemsCount: totalItemsCount, itemsPerPage: LESSON_PER_PAGE}}
              selectAllLessonsInClass={this.selectAllLessonsInClass}
              isAllLessonsSelected={isAllLessonsSelected}
            />
          }
        </div>
      </div>
    );
  }
  _getSelectList() {
    let { 
      classList, 
      selectedClass,
      students, 
    } = this.state;

    let list = Array.from(classList);

    list.map((cls, idx)=>{
      cls.enrolled = this._classAlreadyEnrolled(students, cls);
    });
    return list.map((cls, idx)=>{
      return (
        <ClassItem 
          enrolled={cls.enrolled} 
          selected={cls.classID == selectedClass.classID}
          cls={cls} 
          key={idx}
          onSelectClass={this.onSelectClass(cls)} />
      );
    });
  }

  // NOTE: at this moment, 'not enrolled' will replace 'enrolled.'
  // which means
  // 1. if there is at least one student who is not enrolled,
  // the status will be displayed as 'not enrolled'.
  // 2. if every students are enrolled, it is displayed as enrolled
  _classAlreadyEnrolled(students, cls) {
    let enrolledStudents = students.filter((student, idx)=>{
      let foundCls = find(student.list, (clsItem)=>{
        return clsItem.classID == cls.classID;
      });

      return typeof foundCls != 'undefined';
    });

    return (students.length === 1 && enrolledStudents.length === 1) || enrolledStudents.length === students.length;
  }
}

export default hotline(ModalContent, 'student');



// WEBPACK FOOTER //
// ./src/template/Modals/EnrollClass/ModalContent.js